/**
 * California visitor redirect.
 *
 * California content switching (`body.ca-active` + `.ca-default` / `.ca-only`,
 * see `theme.scss`) is temporarily disabled: the `ca-active` class is never
 * applied, so every visitor who stays on the site sees the default content.
 * California visitors are instead redirected to https://wyldcbd.com:
 *
 *   - `snippets/ca-init.liquid` redirects before paint when the stored region
 *     (`localStorage['wyld_us_state']`) is already California.
 *   - This module covers the rest of the session: IP geo detection committing
 *     California in `src/js/header.js`, or the visitor selecting California in
 *     the header / mobile region controls — both dispatch
 *     `theme:region:state-changed`.
 *
 * Redirects never fire inside the theme editor (`Shopify.designMode`).
 */

const REGION_LS_KEY = 'wyld_us_state'
const CA_STATE = 'California'
const CA_REDIRECT_URL = 'https://wyldcbd.com'

function safeGet(key) {
  try {
    return localStorage.getItem(key)
  } catch {
    return null
  }
}

export function redirectCaliforniaVisitor() {
  if (window.Shopify?.designMode) return
  window.location.replace(CA_REDIRECT_URL)
}

function handleState(state) {
  if (state === CA_STATE) redirectCaliforniaVisitor()
}

function initRegionCaRedirect() {
  handleState(safeGet(REGION_LS_KEY))

  document.addEventListener('theme:region:state-changed', (e) => {
    handleState(e.detail?.state)
  })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRegionCaRedirect)
} else {
  initRegionCaRedirect()
}
